import { ref } from "vue";
import { themeImages } from "./theme-images";
import type { ThemeId } from "./theme-types";
import { tcSetThemeId } from "@/utils/bridge";

export const DEFAULT_THEME: ThemeId = "tg_green";
export const currentTheme = ref<ThemeId>(DEFAULT_THEME);

/** 获取当前主题的图片路径 */
export function getThemeImage<T extends keyof typeof themeImages>(
  page: T,
  imageName: keyof (typeof themeImages)[T][ThemeId]
): string {
  const pageImages = themeImages[page];
  const themeImageMap = pageImages[currentTheme.value] as Record<string, string>;
  return themeImageMap[imageName as string] || "";
}

/** JS 动态切换，仅在极少数场景使用 */
export function setTheme(themeId: ThemeId) {
  currentTheme.value = themeId;
  // 切换 HTML 根元素的 class，触发 CSS 主题切换
  document.documentElement.className = themeId;
  localStorage.setItem("theme_id", themeId);
  tcSetThemeId(themeId);
}

/** 获取当前主题 */
export function getTheme(): ThemeId {
  return currentTheme.value;
}

/** 首屏初始化，根据 query / localStorage / 默认 */
export function initTheme() {
  const urlTheme = new URLSearchParams(window.location.search).get("theme_id") as ThemeId;
  const storedTheme = localStorage.getItem("theme_id") as ThemeId | null;
  const theme = urlTheme || storedTheme || DEFAULT_THEME;
  document.documentElement.className = theme;
  currentTheme.value = theme;

  // 持久化主题设置（URL 参数优先级最高，需要保存）
  if (urlTheme || !storedTheme) {
    localStorage.setItem("theme_id", theme);
  }

  // dev HMR 支持：主题文件更新时触发页面刷新
  if (import.meta.env.DEV && import.meta.hot) {
    import.meta.hot.on("theme-updated", () => {
      console.log("[Theme] 主题已更新");
      // SCSS 会自动热更新，这里可以添加额外的逻辑
    });
  }
}
